import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { getRequestFromEntityFormData } from './eosCreateWorkItem'

export const getUpdateEntityStatusRequest = (data: any, metaData, dedupeData: any) => {
  console.log('data=', data)
  return {
    action: data?.action,
    merchant: {
      ...getRequestFromEntityFormData(data?.editedValues, metaData, dedupeData).merchant,
    },
    comment: data?.comment,
    commentForOps: data?.comment,
    realtimeDedupeSearchResponse: dedupeData,
    ...(data?.internalComment && { internalComment: data?.internalComment }),
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const updateEntityStatus = (body: any, taskInstanceId: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.updateEntityStatus + taskInstanceId + '/complete'),
    method: 'POST',
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateEntityStatus }
